var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg44Covered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84633",
    "data-name": "Group 84633",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.488,
    height: 126.99,
    viewBox: "0 0 111.488 126.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24665",
    "data-name": "Rectangle 24665",
    width: 111.488,
    height: 126.99,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84632",
    "data-name": "Group 84632",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240091",
    "data-name": "Path 240091",
    d: "M49.1,126.99a.659.659,0,0,1-.621-.438c-2.571-7.186-5.232-9.052-10.534-12.769-1.625-1.139-3.466-2.429-5.63-4.092-.637-.489-1.319-.989-2.038-1.517-5.172-3.793-12.256-8.989-18.3-21.407C4.8,72.015.884,51,0,22.523a.659.659,0,0,1,.5-.66C14.41,18.306,33.986,11.65,48.232.146a.66.66,0,0,1,.809-.015C64.635,11.739,87.717,18.954,96.918,21.517a.66.66,0,0,1,.481.686c-.056.726-.129,1.861-.213,3.158-.23,3.558-.517,7.985-.762,9.21a.66.66,0,1,1-1.294-.259c.227-1.139.523-5.7.738-9.036.066-1.016.126-1.933.175-2.633-9.512-2.68-31.908-9.8-47.38-21.15C34.445,12.81,15.213,19.422,1.336,23.01c2.072,63.817,19.374,76.508,29.723,84.1.728.534,1.418,1.04,2.062,1.535,2.141,1.645,3.97,2.927,5.584,4.058,5.083,3.563,7.839,5.495,10.357,11.669,1.8-4.181,6.678-9.447,14.539-15.689,3.834-3.045,7.937-5.939,11.557-8.493,1.894-1.337,3.684-2.6,5.163-3.694a.66.66,0,1,1,.785,1.06c-1.49,1.1-3.286,2.372-5.187,3.713-3.606,2.544-7.692,5.427-11.5,8.448-8.8,6.988-13.739,12.627-14.676,16.76a.661.661,0,0,1-.6.513H49.1",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240092",
    "data-name": "Path 240092",
    d: "M48.888,112.512a.222.222,0,0,1-.181-.094c-1.321-1.9-5.641-5.659-12.84-11.184C26.28,93.878,19.881,84.762,15.73,72.546c-3.665-10.785-5.72-24.033-6.871-44.3a.219.219,0,0,1,.165-.225c17.472-4.477,30.33-10.23,39.308-17.589a.222.222,0,0,1,.275,0c9.071,7.043,25.1,11.88,34.685,14.77,2.114.638,3.939,1.189,5.256,1.635a.219.219,0,0,1,.148.233l-.055.485c-.125,1.1-.315,2.772-.315,3.2a.22.22,0,1,1-.44,0c0-.449.191-2.131.318-3.245l.035-.309c-1.3-.434-3.053-.964-5.074-1.573-9.561-2.885-25.53-7.7-34.689-14.737C39.484,18.206,26.667,23.938,9.308,28.4c2.013,35.2,6.9,57.194,26.827,72.484,6.921,5.311,11.2,9.014,12.741,11.018,1.812-2.613,10.175-10.353,16.525-14.519a.22.22,0,0,1,.241.368c-6.548,4.3-15.235,12.389-16.565,14.65a.218.218,0,0,1-.181.109Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240093",
    "data-name": "Path 240093",
    d: "M103.255,52.9a7.41,7.41,0,1,1-7.409,7.409,7.409,7.409,0,0,1,7.409-7.409",
    transform: "translate(0 0)",
    fill: "#fefbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240094",
    "data-name": "Path 240094",
    d: "M68.677,52.9a7.41,7.41,0,1,1-7.409,7.409A7.409,7.409,0,0,1,68.677,52.9",
    transform: "translate(0 0)",
    fill: "#fefbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240095",
    "data-name": "Path 240095",
    d: "M85.966,42.2a8.233,8.233,0,1,1-8.233,8.233A8.233,8.233,0,0,1,85.966,42.2",
    transform: "translate(0 0)",
    fill: "#fefbf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240096",
    "data-name": "Path 240096",
    d: "M71.641,63.593a5.784,5.784,0,0,1,2.075,2.149,7.412,7.412,0,0,1-10.077,0,5.774,5.774,0,0,1,8-2.149",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240097",
    "data-name": "Path 240097",
    d: "M106.219,63.593a5.784,5.784,0,0,1,2.075,2.149,7.412,7.412,0,0,1-10.077,0,5.774,5.774,0,0,1,8-2.149",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240098",
    "data-name": "Path 240098",
    d: "M89.547,53.327a5.766,5.766,0,0,1,2.017,3.137A8.22,8.22,0,0,1,87.629,58.5H87.6a1.628,1.628,0,0,0-.477-1,1.61,1.61,0,0,0-1.161-.486A1.653,1.653,0,0,0,84.327,58.5a8.161,8.161,0,0,1-3.96-2.033,5.761,5.761,0,0,1,9.18-3.137",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240099",
    "data-name": "Path 240099",
    d: "M68.677,56.192a3.293,3.293,0,1,1-3.293,3.293,3.293,3.293,0,0,1,3.293-3.293",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240100",
    "data-name": "Path 240100",
    d: "M85.966,45.49a3.293,3.293,0,1,1-3.293,3.293,3.293,3.293,0,0,1,3.293-3.293",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240101",
    "data-name": "Path 240101",
    d: "M103.255,56.192a3.293,3.293,0,1,1-3.293,3.293,3.293,3.293,0,0,1,3.293-3.293",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240102",
    "data-name": "Path 240102",
    d: "M96.669,88.3v3.293H80.2V88.3H96.669Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240103",
    "data-name": "Path 240103",
    d: "M66.207,81.714a1.647,1.647,0,1,1-1.647,1.647,1.647,1.647,0,0,1,1.647-1.647",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240104",
    "data-name": "Path 240104",
    d: "M71.147,71.011A1.646,1.646,0,1,1,69.5,72.658a1.647,1.647,0,0,1,1.647-1.647",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240105",
    "data-name": "Path 240105",
    d: "M107.371,71.011a1.646,1.646,0,1,1-1.647,1.647,1.647,1.647,0,0,1,1.647-1.647",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240106",
    "data-name": "Path 240106",
    d: "M102.432,81.714a1.647,1.647,0,1,1-1.647,1.647,1.647,1.647,0,0,1,1.647-1.647",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240107",
    "data-name": "Path 240107",
    d: "M94.2,70.188a1.652,1.652,0,0,1,1.647-1.647,1.659,1.659,0,0,1,1.646,1.647v10.7a4.932,4.932,0,0,1-.988,2.963L95.022,85.83V88.3H81.85V85.83l-2.8-5.763a4.9,4.9,0,0,1-.618-1.836l-.568-4.561a4.479,4.479,0,0,0-.716-1.926L76.3,70.468a1.233,1.233,0,0,1-.214-.7,1.261,1.261,0,0,1,1.268-1.259,4.5,4.5,0,0,1,2.84,1.012,4.446,4.446,0,0,1,1.548,2.585c.444,2.215.93,4.635.93,4.635H83.5l.478-.955a3.265,3.265,0,0,0,.346-1.473V58.662a1.092,1.092,0,0,1,.008-.165,1.65,1.65,0,0,1,1.638-1.481,1.611,1.611,0,0,1,1.161.485,1.64,1.64,0,0,1,.478,1,1.093,1.093,0,0,1,.008.165v9.879a1.651,1.651,0,0,1,1.646-1.646,1.659,1.659,0,0,1,1.647,1.646,1.651,1.651,0,0,1,1.646-1.646A1.659,1.659,0,0,1,94.2,68.541Z",
    transform: "translate(0 0)",
    fill: "#fefcf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240108",
    "data-name": "Path 240108",
    d: "M67.03,81.042V70.188H65.384V81.042a2.47,2.47,0,1,0,1.646,0m-.823,3.142a.823.823,0,1,1,.823-.823.824.824,0,0,1-.823.823",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240109",
    "data-name": "Path 240109",
    d: "M71.147,70.188a2.464,2.464,0,0,0-.823,4.788V85.83H71.97V74.976a2.464,2.464,0,0,0-.823-4.788m0,3.293a.824.824,0,1,1,.823-.823.824.824,0,0,1-.823.823",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240110",
    "data-name": "Path 240110",
    d: "M103.255,81.042V70.188h-1.646V81.042a2.47,2.47,0,1,0,1.646,0m-.823,3.142a.823.823,0,1,1,.823-.823.824.824,0,0,1-.823.823",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240111",
    "data-name": "Path 240111",
    d: "M107.371,70.188a2.464,2.464,0,0,0-.823,4.788V85.83h1.646V74.976a2.464,2.464,0,0,0-.823-4.788m0,3.293a.824.824,0,1,1,.823-.823.824.824,0,0,1-.823.823",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240112",
    "data-name": "Path 240112",
    d: "M95.846,67.718a2.448,2.448,0,0,0-.919.181,2.448,2.448,0,0,0-4.021-1.186,2.392,2.392,0,0,0-2.47-.49V59.138a9.085,9.085,0,0,0,6.479-7.376L98.4,53.677a8.081,8.081,0,1,0,1.673-.96L95,49.927a9.044,9.044,0,0,0-18.061,0l-5.072,2.789a8.33,8.33,0,1,0,1.672.96l3.481-1.915a9.082,9.082,0,0,0,6.48,7.377V74.314a2.462,2.462,0,0,1-.252,1.086l-.69-3.452a5.321,5.321,0,0,0-5.2-4.266,2.088,2.088,0,0,0-1.737,3.245l.848,1.271a3.681,3.681,0,0,1,.586,1.576l.569,4.555a5.61,5.61,0,0,0,.689,2.1l2.72,5.593v1.457H79.38v4.94H97.492v-4.94H95.846V86.1l1.317-1.756a5.8,5.8,0,0,0,1.153-3.458v-10.7a2.473,2.473,0,0,0-2.47-2.469M99.31,65.57a4.937,4.937,0,0,1,7.89,0,6.539,6.539,0,0,1-7.89,0m1.475-6.085a2.47,2.47,0,1,1,2.47,2.47,2.473,2.473,0,0,1-2.47-2.47m9.056.823a6.548,6.548,0,0,1-1.455,4.12,6.585,6.585,0,0,0-2.413-1.876,4.117,4.117,0,1,0-5.435,0,6.588,6.588,0,0,0-2.413,1.876,6.583,6.583,0,1,1,11.716-4.12M64.732,65.57a4.938,4.938,0,0,1,7.891,0,6.541,6.541,0,0,1-7.891,0m1.476-6.085a2.47,2.47,0,1,1,2.47,2.47,2.473,2.473,0,0,1-2.47-2.47m9.056.823a6.548,6.548,0,0,1-1.456,4.12,6.577,6.577,0,0,0-2.413-1.876,4.117,4.117,0,1,0-5.435,0,6.6,6.6,0,0,0-2.413,1.876,6.584,6.584,0,1,1,11.717-4.12m8.53-2.8a7.337,7.337,0,0,1-2.469-1.318,4.917,4.917,0,0,1,9.283,0,7.344,7.344,0,0,1-2.468,1.319,2.449,2.449,0,0,0-4.346,0m-.3-8.73a2.469,2.469,0,1,1,2.469,2.47,2.473,2.473,0,0,1-2.469-2.47m-4.94,1.647a7.41,7.41,0,1,1,13.3,4.472,6.551,6.551,0,0,0-3.164-3.06,4.117,4.117,0,1,0-5.457,0A6.551,6.551,0,0,0,80.073,54.9a7.389,7.389,0,0,1-1.516-4.473m17.289,40.34H81.027V89.122H95.846Zm.823-9.879a4.139,4.139,0,0,1-.823,2.47l-1.647,2.2v1.92H82.673V85.64l-2.911-5.982a4.071,4.071,0,0,1-.51-1.531l-.57-4.556a5.307,5.307,0,0,0-.85-2.285l-.848-1.271a.447.447,0,0,1-.074-.246.44.44,0,0,1,.441-.439,3.669,3.669,0,0,1,3.588,2.941L82,77.562H84l.7-1.407a4.138,4.138,0,0,0,.435-1.84V58.662a.824.824,0,1,1,1.647,0V71.834h1.646V68.541a.824.824,0,0,1,1.647,0v3.293h1.646V68.541a.824.824,0,0,1,1.647,0v3.293h1.646V70.187a.823.823,0,0,1,1.647,0Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg44Covered);
export default __webpack_public_path__ + "static/media/4.4_Covered.0b2ff2569057c7fde99158db1a2f75a6.svg";
export { ForwardRef as ReactComponent };